export type GuestProfilesForms = 'updateProfile';

export const GuestProfilesForms = {
  UpdateProfile: <GuestProfilesForms>'updateProfile',
  UpdateDoNotDisturb: <GuestProfilesForms>'updateDoNotDisturb',
  UpdatePreferredTemperature: <GuestProfilesForms>'updatePreferredTemperature',
};
